// eslint-disable-next-line import/no-unresolved
import 'swiper/swiper-bundle.min.css';
import main from '../../../../assets/js/_main';
import dynamicOverrides from './dynamic-overrides';
import delayLoad from '../../../../assets/js/delayload';
import appendQueryStringParams from './append-qs-params';

window.addEventListener('DOMContentLoaded', () => {
  main();
  dynamicOverrides();
  delayLoad();
  appendQueryStringParams();
  window.s1.alpine.start();
});
